import { render, staticRenderFns } from "./TheItemDefinitiveDeletion.vue?vue&type=template&id=28577f3d"
import script from "./TheItemDefinitiveDeletion.vue?vue&type=script&lang=js"
export * from "./TheItemDefinitiveDeletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports